import './mines-bet-form.scss';

import NiceModal from '@ebay/nice-modal-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppDispatch, useAppSelector } from '@/app/store/hooks';
import { minesActions, selectMinesLoading } from '@/entities/mines';
import { selectUserBalanceByCurrency } from '@/entities/user';
import { MODALS } from '@/shared/config/modals';
import { type CurrencyCode, getGameCurrencyLimits } from '@/shared/lib/currency';
import { BetPanel } from '@/shared/ui/BetPanel';
import { GameActionButton } from '@/shared/ui/GameActionButton';

const MINES_PRESETS = [1, 3, 5, 10, 15, 20, 24];

export function MinesBetForm() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const loading = useAppSelector(selectMinesLoading);
  const [selectedCurrency, setSelectedCurrency] = useState<CurrencyCode>('STARS');
  const balance = useAppSelector(selectUserBalanceByCurrency(selectedCurrency));
  const { minBet, maxBet } = getGameCurrencyLimits('mines', selectedCurrency);

  const [betAmount, setBetAmount] = useState(minBet);
  const [minesCount, setMinesCount] = useState(3);

  const isGift = selectedCurrency === 'GIFT';

  useEffect(() => {
    setBetAmount(minBet);
  }, [minBet, selectedCurrency]);

  const handleStart = () => {
    if (isGift) {
      NiceModal.show(MODALS.GIFT_SELECT, {
        onSelect: (gift: { id: string }) =>
          dispatch(
            minesActions.startGame({
              betAmount: 0,
              minesCount,
              currency: selectedCurrency,
              giftId: gift.id,
            }),
          ),
      });
      return;
    }
    if (betAmount < minBet || betAmount > maxBet || betAmount > balance) return;
    dispatch(minesActions.startGame({ betAmount, minesCount, currency: selectedCurrency }));
  };

  return (
    <>
      <BetPanel
        currency={selectedCurrency}
        onCurrencyChange={setSelectedCurrency}
        onSelectAmount={setBetAmount}
        maxAmount={Math.min(maxBet, balance)}
        disabled={loading}
      />

      <div className="mines-bet-form__field">
        <label className="mines-bet-form__label">{t('mines.minesLabel')}</label>
        <div className="mines-bet-form__presets">
          {MINES_PRESETS.map((n) => (
            <button
              key={n}
              className={`mines-bet-form__preset${minesCount === n ? ' mines-bet-form__preset--active' : ''}`}
              onClick={() => setMinesCount(n)}>
              {n}
            </button>
          ))}
        </div>
      </div>

      <GameActionButton
        label={loading ? t('mines.starting') : isGift ? t('mines.chooseGiftAndPlay') : t('mines.startGame', { amount: betAmount, currency: selectedCurrency })}
        disabled={loading || (!isGift && betAmount > balance)}
        onClick={handleStart}
      />
    </>
  );
}
